import React, { useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";

import LoaderComponent from "../../Components/Generic/LoaderComponent";
import RegisterPremiumCard from "../../Components/AuthenticationComponents/RegisterPremiumCard";
import { useNavigate } from "react-router-dom";

const RegisterPremiumPage = () => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const searchParams = new URLSearchParams(window.location.search);
  const plan = searchParams.get('plan');
  const currency = searchParams.get('currency') || 'eur';

  const navigateToWebpage = () => {
    window.location.replace("http://emotii.ai");
  };

  return (
    <LoaderComponent loading={loading}>
      <LogoWrapper>
        <img src="/emotii.avif" alt="Emotii Logo" />
      </LogoWrapper>
      <Container>
        <RegisterPremiumCard setIsLoading={setLoading} plan={plan} currency={currency} />
      </Container>
    </LoaderComponent>
  );
};

export default RegisterPremiumPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: ${lightThemeColors.menuBackground};
  min-height: 100vh;
  padding: 70px 40px 40px 40px;
  box-sizing: border-box;
  overflow-y: auto;

  @media (max-width: 650px) {
    padding: 50px 20px 20px 20px;
  }
`;

const LogoWrapper = styled.div`
  position: fixed;
  top: 40px;
  left: 40px;
  max-width: 80px;
  width: 100%;
  z-index: 10;

  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 650px) {
    top: 20px;
    left: 20px;
    max-width: 60px;
  }
`;
